import { voidFn } from '@simplisafe/ewok'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'

import type { AffirmClient } from './affirm'

export function getAffirm(fn: (a: AffirmClient) => void) {
  pipe(O.fromNullable(globalThis.window?.affirm), O.fold(voidFn, fn))
}
